
export class RoleEmployer {
  id : any;
  role_id : string;
  employer_id :any;
  role_employer_etat : string;
  
  //occ_id:any = null;




  constructor(){
           
        } 
      
    
   } 